"use client";
import { Tooltip } from "@/_components/lib/ui/tooltip";
import { Image as ChakraImage } from "@chakra-ui/react";
import { EMOJI_MAP, EmojiKey } from "./emojiList";
interface EmojiProps {
  emoji: EmojiKey;
  size?: number | { base: number; md: number };
  tooltip?: string;
  label?: string;
}

export const Emoji = ({ emoji, size = 20, tooltip, label }: EmojiProps) => {
  const baseUrl =
    process.env.NEXT_PUBLIC_CLOUDFRONT_CDN_URL ||
    "https://d137n9fqai29d3.cloudfront.net";
  if (!baseUrl) {
    throw new Error("NEXT_PUBLIC_CLOUDFRONT_CDN_URL is not set");
  }
  const cdnUrl = `${baseUrl}/emojis`;

  return (
    <Tooltip
      content={tooltip}
      openDelay={300}
      positioning={{ placement: "top" }}
      disabled={!tooltip}
    >
      <ChakraImage
        src={`${cdnUrl}/${EMOJI_MAP[emoji]}`}
        alt={label ?? emoji}
        boxSize={size}
        h="fit-content"
        display="inline"
      />
    </Tooltip>
  );
};
export { EMOJI_MAP };
